import sensors from 'sa-sdk-javascript';
import { useGlobSetting } from '/@/hooks/setting'
import { getEnv } from '/@/utils/env';
import { getDevProxyList } from '../../devProxy';
import { useUserStore } from '../store/modules/user';

enum sensorEvents {
    LOGIN = 'login_event',
    ONLINE_TIME = 'online_event',
}

const getCurrentDomain = () => {
    const glob = useGlobSetting();
    let url = glob.domainUrl + glob.apiUrl;

    if(getEnv() === 'development'){
        const {serverName, serverList} = getDevProxyList();
        const serviceUrl= sessionStorage.getItem('serviceUrl') || serverName;
        let server = serverList.find(item=>item.configPath===serviceUrl);
        url = server?.url;
    }

    return url;
}

const sensorsTrack = sensors.track;

const initSensors = () => {
    const url = getCurrentDomain();

    sensors.init({
        server_url: `${url}/sys/event/click/push/log/ajax`,
        is_track_single_page:false, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
        use_client_time:true, 
        send_type:'ajax',
        show_log: false,
        heatmap: {
           //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
           clickmap:'not_collect',
           //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
           scroll_notice_map:'not_collect'
        }
    });
    // sensors.quick('autoTrack'); //用于采集 $pageview 事件。

    // 注册公共属性
    sensors.registerPage({
        $title:'',
        $referrer:'',
        $latest_scene:'',
        $referrer_title:'',
        $model: '',
        $latest_traffic_source_type: '',
        $latest_search_keyword: '',
    });
}

const trackBuryPoint = (event: sensorEvents, selfParams?: object) => {
    const userStore = useUserStore();
    const params = {
        source: userStore.getUserInfo?.tenantType,
        userId: userStore.getUserInfo?.id,
    }

    sensorsTrack(event, {...params, ...selfParams})
}

const trackLoginBuryPoint = () => {
    sessionStorage.setItem('loginStartTime', String(new Date().getTime()));
    return trackBuryPoint(sensorEvents.LOGIN)
}

const trackOnlineTimeBuryPoint = () => {
    trackBuryPoint(sensorEvents.ONLINE_TIME, {
        startTime: sessionStorage.getItem('loginStartTime'),
        endTime: String(new Date().getTime()),
    })

    sessionStorage.setItem('loginStartTime', null);
}

export {
    sensorsTrack,
    sensorEvents,
    trackBuryPoint,
    trackLoginBuryPoint,
    trackOnlineTimeBuryPoint,
};

export default initSensors;